import React from 'react';
import { AuthSubmitProps } from './types';
import { ArcButton, ArcStack } from '@src/core/ui';

const AuthSubmit: React.FC<AuthSubmitProps> = (props) => {
  const { buttonText, isLoading } = props;

  return (
    <ArcStack 
      gap={1}
      mx='auto'
      width='100%'
      maxWidth={300}
      mt={4}>
      <ArcButton.brand type='submit' isLoading={isLoading}> {buttonText} </ArcButton.brand>
    </ArcStack> 
  );
};

export default AuthSubmit;